module.exports = __webpack_public_path__ + "static/image/service/pc/bmart.jpg?0e741a6d";